import { ColorScheme } from "../useColorHarmonies";
import { Tab } from "./Tab/Tab";
import { useTabs } from "./useTabs";

interface TabsProps {
    tab: ColorScheme;
    setTab: (tab: ColorScheme) => void;
}

export const Tabs = ({ tab, setTab }: TabsProps) => {
    const { sliderRef, handleClick } = useTabs(setTab);
    return (
        <div className="px-4 select-none">
            <div className="flex gap-4">
                <div
                    className="flex transition-all duration-250 ease-in-out font-semibold capitalize overflow-y-hidden overflow-x-auto scrollbar-hide"
                    ref={sliderRef}
                >
                    <Tab
                        tab="complementary"
                        activeTab={tab}
                        handleClick={() => handleClick("complementary", 0)}
                        translationKeyName="complementary"
                    />
                    <Tab
                        tab="triadic"
                        activeTab={tab}
                        handleClick={() => handleClick("triadic", 1)}
                        translationKeyName="triadic"
                    />
                    <Tab
                        tab="tetradic"
                        activeTab={tab}
                        handleClick={() => handleClick("tetradic", 2)}
                        translationKeyName="tetradic"
                    />
                    <Tab
                        tab="analogous"
                        activeTab={tab}
                        handleClick={() => handleClick("analogous", 3)}
                        translationKeyName="analogous"
                    />
                    <Tab
                        tab="monoChromatic"
                        activeTab={tab}
                        handleClick={() => handleClick("monoChromatic", 4)}
                        translationKeyName="mono-chromatic"
                    />
                </div>
            </div>
        </div>
    );
};
